export default {
  DAILY: "daily",
  WEEKLY: "weekly",
  MONTHLY: "monthly",
  STATIC: "static",
  COMPETITION: "competition",
};
